import { createAsyncThunk } from "@reduxjs/toolkit";
import { ticketAxios } from "@modules/helpdesk/services/ticketAxios";
import { axiosInstance, axiosInstanceHelpDesk } from "@config/axiosConfig";

// Async thunks
export const fetchTickets = createAsyncThunk(
    "tickets/fetchTickets",
    async (params: any, { rejectWithValue }) => {
        try {
            const { page, rowsPerPage, searchTerm, filters, mobile } = params;

            // Only fetch if mobile number is available
            if (!mobile) {
                return {
                    tickets: [],
                    statusList: [],
                    totalItems: 0,
                    currentPage: page,
                };
            }

            const fromDateStr = filters?.fromDate || "";
            const toDateStr = filters?.toDate || "";
            const statusID = filters?.status || "";
            const search = searchTerm || "";

            const response = await axiosInstanceHelpDesk.get(
                `/ticket-history-list?page=${page}&limit=${rowsPerPage}&search=${search}&fromDate=${fromDateStr}&toDate=${toDateStr}&statusID=${statusID}`
            );

            const json = response.data;

            if (json?.success) {
                return {
                    tickets: json.data?.data || [],
                    statusList: json.data?.statusList || [],
                    totalItems: json.data?.totalItems || 0,
                    currentPage: page,
                };
            } else {
                return rejectWithValue(json?.message || "Failed to fetch tickets");
            }
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);

export const createTicket = createAsyncThunk(
    "tickets/createTicket",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axiosInstanceHelpDesk.post("/create-ticket-web", payload);
            const json = response.data;

            // Check if the response has success property
            if (json?.success) {
                return json; // Return the entire response, not just json.data
            } else {
                return rejectWithValue({
                    message: json?.message || "Failed to create ticket",
                    data: json // Include the full response for debugging
                });
            }
        } catch (error: any) {
            return rejectWithValue({
                message: error.response?.data?.message || "Network error",
                error: error
            });
        }
    }
);

export const fetchTicketDetails = createAsyncThunk(
    "tickets/fetchTicketDetails",
    async (ticketID: string | number, { rejectWithValue }) => {
        try {
            const response = await axiosInstanceHelpDesk.get(`/ticketDetailsById/${ticketID}`);
            const json = response.data;

            if (json?.success) {
                return json.data;
            } else {
                return rejectWithValue(json?.message || "Failed to fetch ticket details");
            }
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);

 